<script>
  export let className = '';
  export let imageSrc = '';
  export let imageSize = 'small';
  export let text = '';
  export let title = '';
</script>


<div class={`bg-white rounded-[10px] p-8 flex flex-col items-center text-center text-black ${className}`}>
  <img class="mb-2" width={imageSize === 'large' ? 48 : 32} src={imageSrc} alt="icon" />
  <h4 class="text-xl leading-6 font-semibold mb-1.5">{@html title}</h4>
  <p class="text-base leading-[22px] font-light">{@html text}</p>
</div>  